<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Edycja numeracji montaży
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-btn
                            color="secondary"
                            depressed
                            small
                            @click="numberOrdinalNumberAutomatically"
                        >
                            Autonumeracja
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                            :headers="headers"
                            :items="job.jobImposition"
                            :mobile-breakpoint="0"
                            hide-default-footer
                            disable-pagination
                            name="jobImpositionData"
                        >
                            <template #item.index="{item}">
                                {{ item.index + 1 }}
                            </template>
                            <template #item.previousOrdinalNumber="{item}">
                                Montaż {{ previousOrdinalNumber(item) }}
                            </template>
                            <template #item.ordinalNumber="{item}">
                                <v-text-field
                                    v-model="item.ordinalNumber"
                                    v-mask="'##'"
                                    dense
                                    outlined
                                    hide-details
                                    :error="ordinalNumberErrors(item.index)"
                                    @input="$v.$touch()"
                                />
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import parse from '@/mixins/parse'

import Vue from 'vue'
import { required, minValue, helpers } from 'vuelidate/lib/validators'
import { VueMaskDirective } from 'v-mask'

Vue.directive('mask', VueMaskDirective)

export default {
    name: 'ImpositionOrdinalNumbersDialog',
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        jobData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            job: {
                jobImposition: []
            },
            headers: [
                {
                    text: 'Lp.',
                    value: 'index',
                    sortable: false,
                },
                {
                    text: 'Montaż',
                    value: 'previousOrdinalNumber',
                    sortable: false,
                },
                {
                    text: 'Nowy nr montażu',
                    value: 'ordinalNumber',
                    width: 150,
                    sortable: false,
                }
            ]
        }
    },
    validations() {
        const ordinalNumberHelper = () => {
            return helpers.withParams({ type: 'ordinalNumberHelper' }, (value, jobImpositionModel) => {
                return !this.job.jobImposition.some(jobImposition => {
                    if (jobImposition.id === jobImpositionModel.id) return

                    return parseInt(jobImposition.ordinalNumber) === parseInt(value)
                })
            })
        }

        const rules = {
            job: {
                jobImposition: {
                    $each: {
                        ordinalNumber: {
                            required,
                            minValue: minValue(1),
                            isUnique: ordinalNumberHelper(),
                        }
                    }
                }
            }
        }

        return rules
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.job = JSON.parse(JSON.stringify(this.jobData))
                this.job.jobImposition = this.job.jobImposition.map((item, index) => ({
                    ...item,
                    index
                }))
            } else {
                setTimeout(() => {
                    this.$v.$reset()
                    this.job = {}
                }, 500)
            }
        }
    },
    methods: {
        previousOrdinalNumber(jobImposition) {
            return this.jobData.jobImposition.find(item => item.id === jobImposition.id).ordinalNumber
        },
        numberOrdinalNumberAutomatically() {
            this.job.jobImposition.forEach((jobImposition, index) => {
                jobImposition.ordinalNumber = index + 1
            })
        },
        onSave() {
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$store.dispatch('toggleCircularLoader', true)

            this.$store.dispatch('jobs/saveJob', {
                id: this.job.id,
                jobImposition: this.job.jobImposition
            })
                .then(response => {
                    this.$emit('on-save', response.data)
                    this.onClose()
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.$store.dispatch('toggleCircularLoader', false)
                })

        },
        onClose() {
            this.$emit('on-close')
        },
        ordinalNumberErrors(index) {
            if (!this.$v.job.jobImposition.$each[index].ordinalNumber.$dirty) return

            return this.$v.job.jobImposition.$each[index].ordinalNumber.$invalid
        }
    }
}
</script>